// CSS styles
import 'ol/ol.css'; // does not work anymore
import '../css/list.css';
import '../css/loader.css';
import '../css/main.css';
import '../css/notify.css';
import '../css/table.css';
import '../css/user.css';
import '../css/wizard.css';
import '../css/wms.css';

// Modules
import { getCenter } from 'ol/extent';
import { transformExtent } from 'ol/proj';
import { View } from 'ol';

import { filterDatalist, invalidPlanIdList, loadCodes } from './formal';
import { basemapPromise, getWFS, getWMS, subWMS } from './map/layers';
import { drawInitialization } from './map/draw';
import { getLayerById, visibleComputationArea } from './map/layer-tools';
import { createPopup } from './map/popup';
import {
  getLegendUrl, map, getListSelectedFeatures
} from './map/tools';
import { idb, restoredLocation } from './map/storage';
import { authenticationCheck } from './request/authentication';
import {
  cancelMain, getEmissions, sendFeaturesToBackend
} from './request/computation';
import { saveGeometryToFile } from './save';
import {
  activateClickInteractions as activateTableClickInteractions,
  compareTables, localeAndSummary, removeColumn
} from './table';
import { addInteractionToTable } from './table-interaction';
import * as notification from './notify';
import { mangel, retrievePlanCategory } from './util';
import * as _wizard from './wizard';

console.log(__APP_VERSION__, import.meta.env);
versjon.innerHTML= `v ${__APP_VERSION__}`;

const ws = '/klimagasskalkulator_ws';

infoBtn.onclick = () => modal.showModal();
menyBtn.onclick = () => meny.classList.toggle('open');

basemapPromise().then(baseMapLayers => {
  const bm = baseMapLayers.graatoner[33];
  map.getLayers().insertAt(0, bm);
  map.getLayers().insertAt(1, subWMS);
  const nib = baseMapLayers.flybilder[33];
  nib.setVisible(false);
  map.getLayers().insertAt(2, nib);

  const p = bm.getSource().getProjection();
  const e = p.getExtent();

  const ec4258 = [-22, 48, 46, 75]; // degrees
  const extentConstraint = transformExtent(ec4258, 'EPSG:4258', p.getCode());

  const center = restoredLocation ? map.getView().getCenter() : getCenter(e);
  const zoom = restoredLocation ? map.getView().getZoom() : 2.8;
  map.setView(new View({
    center,
    extent: extentConstraint,
    projection: p,
    zoom,
    maxZoom: 17,
    minZoom: 2
  }));
});

// Grunnkart WMS:
map.addLayer(getWMS('grunnkart'));
// Other WMSes:
[
  'ar5', 'skogbonitet', 'gnr', 'eiendom',
  'kp', 'kpp', 'kpf', 'kpfp',
  'kdp', 'kdpp', 'kdpf', 'kdpfp',
  'rp', 'rpp', 'rpf', 'rpfp',
  'pip', 'tønsberg'
].forEach(p => {
  const wms = (p === 'tønsberg') ? getWFS(p) : getWMS(p);
  map.addLayer(wms);
  // getLayerById(p).setVisible(false);
  wms.setVisible(false);
});

// Add WMS's legend:
ar5LegendImg.src = getLegendUrl('ar5', 'arealtype');
abLegendImg.src = getLegendUrl('grunnkart', 'arealbruk');
tsLegendImg.src = getLegendUrl('grunnkart', 'treslag');
sbLegendImg.src = getLegendUrl('grunnkart', 'skogbonitet');
oLegendImg.src = getLegendUrl('grunnkart', 'organisk');
bLegendImg.src = getLegendUrl('grunnkart', 'bebygd');
klLegendImg.src = getLegendUrl('grunnkart', 'kraftlinje');
rpfpLegendImg.src = getLegendUrl('rpfp', 'planomrade_vn2');
authorizedLegendImg.src = getLegendUrl('authorized', 'autorisert_planomrade');

authenticationCheck(true);

drawInitialization(map);

notification.initialize();
_wizard.initialize();

createPopup();

makePlanBtn.onclick = () => _wizard.moveTo('selection');
cancelPlanBtn.onclick = () => _wizard.moveTo('home');

const results = document.getElementById('resultsContent');

// Update opacity in sessionStorage:
commonSlider.onchange = () => {
  listOfLayers.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
    const li = cb.parentNode.parentNode;
    const originalSlider = li.querySelector('.slider');
    originalSlider.value = commonSlider.value;
    originalSlider.dispatchEvent(new Event('change'));
  });
};
// Update opacity on map:
commonSlider.oninput = () => {
  listOfLayers.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
    const li = cb.parentNode.parentNode;
    const originalSlider = li.querySelector('.slider');
    originalSlider.value = commonSlider.value;
    originalSlider.dispatchEvent(new Event('input'));
  });
};

const loadingExtraTables = (b) => {
  const togglers = ['toggleComparedEmissions', 'toggleCurrentEmissions'];
  if (b) togglers.map(t => document.getElementById(t).classList.add('loading'));
  else togglers.map(t => document.getElementById(t).classList.remove('loading'));
};

activateTableClickInteractions();

queryBtn.onclick = () => {
  if (queryBtn.classList.contains('loading')) {
    cancelMain();
    return;
  }
  if (!wizard.classList.contains('logged-in')) {
    notification.warn('Krever pålogging');
    return;
  }

  const filteredFeatures = getListSelectedFeatures();

  const invalidList = invalidPlanIdList(filteredFeatures);
  if (invalidList && !confirm(
    'Du har lastet opp en arealplan der en eller flere geometrier har ' +
    'ugyldig arealformål.\n' +
    'Planer med ugyldig arealformål: [' + invalidList + '].\n' + mangel() +
    '\nVil du forsette?'
  )) return;

  if (filteredFeatures.length > 0) {
    queryBtn.classList.add('loading');
    // queryBtn.disabled = true;
    sendFeaturesToBackend(filteredFeatures, 'main').then(id => {
      const ready = { current: false, planned: false };
      getEmissions(id, 'main').then(promised => {
        promised.id = 'plannedEmissions';
        addInteractionToTable(promised);
        localeAndSummary(promised);
        results.querySelector('#plannedEmissions').replaceWith(promised);
        ready.planned = true;
        _wizard.moveTo('results');
        visibleComputationArea(id.request);
        // Prepare comparison between current and planned emissions:
        if (ready.current)
          addInteractionToTable(compareTables(currentEmissions, promised), true);
      }).catch(e => notification.warn(e.statusText))
      .finally(f => queryBtn.classList.remove('loading'));
      // Prepare query for current emissions:
      loadingExtraTables(true);
      getEmissions(id, 'main', 'today').then(table => {
        table.id = 'currentEmissions';
        addInteractionToTable(table);
        removeColumn(table, 'Arealbruk plan');
        localeAndSummary(table);
        results.querySelector('#currentEmissions').replaceWith(table);
        ready.current = true;
        // Prepare comparison between current and planned emissions:
        if (ready.planned)
          addInteractionToTable(compareTables(table, plannedEmissions), true);
      }).catch(e => notification.warn(e.statusText))
      .finally(f => loadingExtraTables(false));
    }).catch(e => {
      console.log(e);
      notification.warn(e.statusText);
      queryBtn.classList.remove('loading'); // if geoupload was cancelled
    });
  }
};

saveGeometryBtn.onclick = () => saveGeometryToFile();

const ua = navigator.userAgent;
const epiphany = ua.includes('AppleWebKit') && ua.includes('Version');
const v = `${epiphany ? '[1001] ' : ''}Bebyggelse og anlegg`;
const v1 = 'Vann';
formål.value = v; // to be able to proceed when Nåværende is default choice
fremtidig.value = v1; // to be able to proceed when Nåværende is default choice

const pk = retrievePlanCategory();
if (pk) {
  if (kommuneRadio.checked || reguleringsRadio.checked) {
    formål.value = '';
    formålChoiceGroup.hidden = false;
    filterDatalist(pk);
  } else if (fremtidigRadio.checked) {
    fremtidig.value = '';
    fremtidigChoiceGroup.hidden = false;
  }
}

const visibleFormålChoice = (visible) => {
  formålChoiceGroup.hidden = !visible;
  formål.value = visible ? '' : v; // need something to validate form
};
const visibleFremtidigChoice = (visible) => {
  fremtidigChoiceGroup.hidden = !visible;
  fremtidig.value = visible ? '' : v1; // need something to validate form
};
const planCategoryChosen = (radio) => {
  filterDatalist(radio.value);
  visibleFormålChoice(['currentRadio', 'fremtidigRadio'].indexOf(radio.id) < 0);
  visibleFremtidigChoice(radio.id === 'fremtidigRadio');
};
currentRadio.onchange = (e) => planCategoryChosen(e.target);
fremtidigRadio.onchange = (e) => planCategoryChosen(e.target);
kommuneRadio.onchange = (e) => planCategoryChosen(e.target);
reguleringsRadio.onchange = (e) => planCategoryChosen(e.target);

fetch(`${ws}/fremtidigekategorier`).then(
  r => r.ok ? r.json() : [{ id: 9, alleTxt: 'Vann' }]
).then(jsonArray =>
  jsonArray.forEach(j => {
    const o = document.createElement('option');
    o.value = j.alleTxt;
    o.dataset.code = j.id;
    fremtidigList.appendChild(o);
  })
);

fetch(`${ws}/k4ivkoder`).then(r => r.ok ? r.json() : [{
  id: 110,
  datakilde: 'Kommuneplan',
  katNiva2: 'Bebygd',
  tekst: 'Bebyggelse og anlegg',
  kode: 1001,
  ivkodeNiva2: 'I055V045W000'
}]).then(loadCodes);
